import React, { useState, useCallback, useEffect } from "react";
import { Container } from "./styles";
import CKEditor from "ckeditor4-react";

const NewTextEditor = (props) => {
  useEffect(() => {
    didMount();
  }, [props.default]);

  const didMount = useCallback(async () => {
    if (props.default) {
      props.text.current = props.default;
    }
  }, [props.default]);

  const handleChange = useCallback(
    ({ editor }) => {
      const data = editor.getData();
      props.text.current = data;
      typeof props?.onChangeText === "function" && props?.onChangeText(data);
    },
    [props.text, props?.onChangeText]
  );

  return (
    <Container>
      <style>{`
        .cke_button_label {
          display: none !important;
        }

        .cke_toolbar {
          display: flex !important;
          justify-content: space-around !important;
        }

        [class$="_label"] {
          display: none !important;
        }

        #cke_1_toolbox { 
          display: flex !important;
        }

        .cke_notifications_area {
          display: none !important;
        }
      `}</style>
      <CKEditor
        data={props.default}
        // config={{
        //   toolbar: [['Bold']]
        // }}
        onChange={handleChange}
      />
    </Container>
  );
};

export default NewTextEditor;
